import layer from 'layui-layer'
import CryptoJS from './CryptoJS'
import { getCookie } from '@/assets/js/common/common.js'
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: getCookie('userLanguage') ? getCookie('userLanguage') : 'zh',
  messages: {
    zh: require('../assets/i18n/zh'),
    en: require('../assets/i18n/en')
  }
})

export default {
  tipMsg: {
    phone: i18n.t('TipPhoneFormatError'),
    password: i18n.t('Password'),
    identifyingCode: i18n.t('VerificationCode'),
    company: i18n.t('Company'),
    name: i18n.t('PFormNameInput'),
    setPwd: i18n.t('TipPwdFormat')
  },
  showTip(e, type) {
    if (e.target.value === '') {
      layer.msg(this.tipMsg[type])
    }
  },
  checkPhone(e) {
    const res = this.validatePhone(e.target.value)
    if (!res) {
      layer.msg(this.tipMsg.phone)
      return
    }
  },
  validatePhone(phone) {
    // return phone && /^1(3|4|5|6|7|8|9)\d{9}$/.test(phone);
    return phone !== ''
  },
  validatePwd(password) {
      // var passwordreg = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{6,20}$/
      var passwordreg = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{6,20}$/
      return passwordreg.test(password) && !password.includes(' ')
  },
  validateStr(str) {
    return str && /^[A-Za-z]{6,20}$/.test(str)
  },
  CryptoJS
}



// WEBPACK FOOTER //
// ./src/utils/index.js